<template>
    <div class="modal modal-filter-type" aria-labelledby="filterTypesButton">
        <div class="modal-dropdown modal-dropdown-filter-type">
            <ul>
                <li v-for="(item, index) in items" :key="index">
                    <slot name="modalFilterType" :props="item"></slot>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueLodash from "vue-lodash";
import lodash from "lodash";

Vue.use(VueLodash, {lodash: lodash})

export default {
    props: ['items'],
};

// export default modalFilterDropdown;
</script>


